<template src="./notificationTemplate.template.html"></template>
<script>
  import Fuse from 'fuse.js'
  import tippy from 'tippy.js'
  import Icon from '../components/Icon'
  import { Editor, EditorContent, EditorMenuBar } from 'tiptap'
  import foliomodal from "../../reservations/reservationDetailVue/folioRecalculateConfirmationModal.vue";
  import {
    Blockquote,
    CodeBlock,
    HardBreak,
    Heading,
    HorizontalRule,
    OrderedList,
    BulletList,
    ListItem,
    TodoItem,
    TodoList,
    Bold,
    Code,
    Italic,
    Link,
    Strike,
    Underline,
    History,
    Mention,
    Table,
    TableCell,
    TableHeader,
    TableRow,
    Image
  } from 'tiptap-extensions'
  export default {
    components: {
      EditorContent,
      EditorMenuBar,
      Icon,
      foliomodal
    },
    data() {
      return {
        Searchtext: '',
        EntityName: null,
        box: "",
        displaySectionValue: 'section1',
        templateDetailList: [],
        selectedParam: {},
        parameters: [],
        TemplateTypeId: null,
        ActionId: null,
        AttributeNames: [],
        DocumentAttributes: [],
        isDocumentCustomTabModal: false,
        EntityNames: [],
        templatesTypeList: [],
        templateDetail: {},
        actionTypesList: [],
        selectedTemplateType: null,
        DocumentTemplateId: null,
        isCustomTab: false,
        DocumentAttributeName: null,
        DocumentColumnName: '',
        // editor: new Editor({
        //   extensions: [
        //     new Blockquote(),
        //     new BulletList(),
        //     new CodeBlock(),
        //     new HardBreak(),
        //     new Heading({ levels: [1, 2, 3] }),
        //     new HorizontalRule(),
        //     new ListItem(),
        //     new OrderedList(),
        //     new TodoItem(),
        //     new TodoList(),
        //     new Link(),
        //     new Bold(),
        //     new Code(),
        //     new Italic(),
        //     new Strike(),
        //     new Underline(),
        //     new History(),
        //     new Mention({
        //       // a list of all suggested items
        //       items: () => [
        //         { id: 1, name: 'Philipp Kühn' },
        //         { id: 2, name: 'Hans Pagel' },
        //         { id: 3, name: 'Kris Siepert' },
        //         { id: 4, name: 'Justin Schueler' },
        //       ],
        //       // is called when a suggestion starts
        //       onEnter: ({
        //         items, query, range, command, virtualNode,
        //       }) => {
        //         this.query = query
        //         this.filteredUsers = items
        //         this.suggestionRange = range
        //         this.renderPopup(virtualNode)
        //         // we save the command for inserting a selected mention
        //         // this allows us to call it inside of our custom popup
        //         // via keyboard navigation and on click
        //         this.insertMention = command
        //       },
        //       // is called when a suggestion has changed
        //       onChange: ({
        //         items, query, range, virtualNode,
        //       }) => {
        //         this.query = query
        //         this.filteredUsers = items
        //         this.suggestionRange = range
        //         this.navigatedUserIndex = 0
        //         this.renderPopup(virtualNode)
        //       },
        //       // is called when a suggestion is cancelled
        //       onExit: () => {
        //         // reset all saved values
        //         this.query = null
        //         this.filteredUsers = []
        //         this.suggestionRange = null
        //         this.navigatedUserIndex = 0
        //         this.destroyPopup()
        //       },
        //       // is called on every keyDown event while a suggestion is active
        //       onKeyDown: ({ event }) => {
        //         // pressing up arrow
        //         if (event.keyCode === 38) {
        //           this.upHandler()
        //           return true
        //         }
        //         // pressing down arrow
        //         if (event.keyCode === 40) {
        //           this.downHandler()
        //           return true
        //         }
        //         // pressing enter
        //         if (event.keyCode === 13) {
        //           this.enterHandler()
        //           return true
        //         }
        //         return false
        //       },
        //       // is called when a suggestion has changed
        //       // this function is optional because there is basic filtering built-in
        //       // you can overwrite it if you prefer your own filtering
        //       // in this example we use fuse.js with support for fuzzy search
        //       onFilter: (items, query) => {
        //         if (!query) {
        //           return items
        //         }
        //         const fuse = new Fuse(items, {
        //           threshold: 0.2,
        //           keys: ['name'],
        //         })
        //         return fuse.search(query)
        //       },
        //     }),
        //   ],
        //   content: `
        //     <h2>
        //      TEST
        //     </h2>
        //     <p>
        //       type here 
        //     </p>
        //   `,
        //   onUpdate: ({ getJSON, getHTML }) => {
        //     this.json = getJSON()
        //     this.html = getHTML()
        //   },
        // }),
        editor: null,
        subjectEditor: null,
        fromEditor: null,
        toEditor: null,
        ccEditor: null,
        subject: null,
        content: '',

        json: 'Update content to see changes',
        html: 'Update content to see changes',
        query: null,
        suggestionRange: null,
        filteredUsers: [],
        navigatedUserIndex: 0,
        insertMention: () => { },
        observer: null,
        RecepientsList: [],
        Temp_Status: {},
        statusList: [],
        allowedTemplateTypes : [1,2,4,5],
        selectedDocumentType: 1,
        modalParams: {},
      }
    },
    methods: {
      AddDocumentCustomTab(){
        let vm = this;
        
        let fullUrl = window.location.href;
        let notificationId = fullUrl.split("/").slice(-1)[0];
      if(notificationId === "-1"){
        vm.isDocumentCustomTabModal = false;
        alert("Please Save the Template");
      }else{
        vm.DocumentTemplateId = parseInt(window.location.href.split("/").slice(-1)[0]);
        vm.isDocumentCustomTabModal = true;
      }
      },
      AddTab(){
        let vm = this;
        let DocumentAttributeNameList = vm.DocumentAttributes.map((name)=>name.AttributeName);
        const  roleAttributeName = vm.DocumentAttributeName.trim().toLowerCase();
        const exists = DocumentAttributeNameList.some(role => role.toLowerCase() === roleAttributeName);
        console.log('DocumentAttributes============>', exists);
        if (vm.DocumentAttributeName && !exists) {
          let camelCaseStr = vm.DocumentAttributeName
            .trim()
            .toLowerCase()
            .split(' ')
            .map((word, index) =>
              index === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1)
            )
            .join('');
          vm.DocumentColumnName = camelCaseStr;
          if (vm.DocumentTemplateId) {
            vm.InsertDocumentEntityAttribute();
          }
          vm.$store.dispatch("toastr", {
                type: "success",
                header: "success!",
                message: "Successfully Added Custom Tab!"
          });
        }else{
          if(vm.DocumentAttributeName !== "" && exists){
            vm.$store.dispatch("toastr", {
                type: "warning",
                header: "Warning!",
                message: "Duplicate Custom Tab Not Allowed!"
          });
          }else{

            vm.$store.dispatch("toastr", {
                  type: "warning",
                  header: "Warning!",
                  message: "Provide Valid Custom Tab!"
            });
          }
        }
        


      },
      closeCustomTabModal(){
        let vm = this;
        vm.isDocumentCustomTabModal = false;
        vm.DocumentAttributeName = null;
      },
      addImageToTemplate(command){
        const src = prompt('Enter Image URL')
          if (src !== null) {
          command({ src })
        }
      },
      preview(){
        let vm = this;
        vm.initEditor();
      },
      htmlToText(html) {
        // Create a DOMParser instance
        const parser = new DOMParser();

        // Parse the HTML string
        const doc = parser.parseFromString(html, 'text/html');

        // Traverse the DOM to extract text content
        const text = this.getTextContent(doc.documentElement);

        return text;
      },
      getTextContent(node) {
        let text = '';
        // Traverse through child nodes
        for (let i = 0; i < node.childNodes.length; i++) {
          const childNode = node.childNodes[i];
          // If the node is a text node, append its content to the result
          if (childNode.nodeType === Node.TEXT_NODE) {
            text += childNode.textContent;
          } else if (childNode.nodeType === Node.ELEMENT_NODE) {
            // If it's an element node, recursively call getTextContent
            text += this.getTextContent(childNode);
          }
        }

        return text;
      },
      calculateCharacterCount(text) {
        // Use a regular expression to remove any non-alphanumeric characters
        const cleanedText = text.replace(/[^\w\s]/gi, '');
        // Count the number of characters
        return cleanedText.length;
      },
      Save_TemplateData() {
        let vm = this;
        if(vm.templateDetail.TemplateName == "" || vm.templateDetail.TemplateName == null || vm.templateDetail.TemplateName == undefined){
          vm.$store.dispatch("toastr", {
                type: "warning",
                header: "Warning!",
                message: "Please enter template name!"
              });
          return;
        }
        var payload = {};
        if(vm.selectedTemplateType == 1){
          payload = {
            ModuleAction: "Save_TemplateData",
            TemplateId: vm.$route.params.TemplateId,
            TemplateName: vm.templateDetail.TemplateName,
            TemplateDescription: vm.templateDetail.TemplateDescription ? vm.templateDetail.TemplateDescription : "",
            StatusId: vm.Temp_Status.StatusId,
            TemplateTypeId: vm.selectedTemplateType,
            HTMLObj: vm.templateDetail.HTMLObj,
            JSONObj: JSON.stringify(vm.templateDetail.JSONObj),
            SubjectLineJson: JSON.stringify(vm.templateDetail.SubjectLineJson),
            SubjectLineHTML: vm.templateDetail.SubjectLineHTML,

            FromJson: JSON.stringify(vm.templateDetail.FromJson),
            FromHTML: vm.templateDetail.FromHTML,

            ReplyToJson: JSON.stringify(vm.templateDetail.ReplyToJson),
            ReplyToHTML: vm.templateDetail.ReplyToHTML,

            CCJson: JSON.stringify(vm.templateDetail.CCJson),
            CCHTML: vm.templateDetail.CCHTML,
          }
        }
        if(vm.selectedTemplateType == 2  || vm.selectedTemplateType == 4){
          payload = {
            ModuleAction: "Save_TemplateData",
            TemplateId: vm.$route.params.TemplateId,
            TemplateName: vm.templateDetail.TemplateName,
            TemplateDescription: vm.templateDetail.TemplateDescription ? vm.templateDetail.TemplateDescription : "",
            StatusId: vm.Temp_Status.StatusId,
            TemplateTypeId: vm.selectedTemplateType,
            HTMLObj: vm.templateDetail.HTMLObj,
            JSONObj: JSON.stringify(vm.templateDetail.JSONObj),
            SubjectLineJson: "",
            SubjectLineHTML: "",
            FromJson: "",
            FromHTML: "",
            ReplyToJson: "",
            ReplyToHTML: "",
            CCJson: "",
            CCHTML: "",
          }
          let textContent = this.htmlToText(payload.HTMLObj)
          let textContentCount = this.calculateCharacterCount(textContent);
          console.log("textContentCount ===>",textContentCount);
          if(textContentCount > 160 && vm.selectedTemplateType != 4){
            vm.$store.dispatch("toastr", {
                type: "warning",
                header: "SMS Template exceeds maximum character limit",
                message: `Please limit your message to 160 characters or less. Got ${textContentCount}`
              });
            return;
          }
        }
        if (vm.selectedTemplateType === 5) {
            let mandatoryFieldsFilled = false;
            let warningMessage = "";
            if (vm.selectedDocumentType === 1) {
                if (
                    vm.templateDetail.SubjectLineHTML &&
                    vm.templateDetail.SubjectLineHTML.length > 7 &&
                    vm.templateDetail.HTMLObj &&
                    vm.templateDetail.HTMLObj.length > 7
                ) {
                    payload = {
                        ModuleAction: "Save_TemplateData",
                        TemplateId: vm.$route.params.TemplateId,
                        TemplateName: vm.templateDetail.TemplateName,
                        TemplateDescription: vm.templateDetail.TemplateDescription ? vm.templateDetail.TemplateDescription : "",
                        StatusId: vm.Temp_Status.StatusId,
                        TemplateTypeId: vm.selectedTemplateType,
                        HTMLObj: vm.templateDetail.HTMLObj,
                        JSONObj: JSON.stringify(vm.templateDetail.JSONObj),
                        SubjectLineJson: "",
                        SubjectLineHTML: vm.templateDetail.SubjectLineHTML,
                        FromJson: "",
                        FromHTML: "",
                        ReplyToJson: "",
                        ReplyToHTML: "",
                        CCJson: "",
                        CCHTML: "",
                        FileName: ""
                    };
                    mandatoryFieldsFilled = true;
                } else {
                    warningMessage = "Please fill all mandatory fields!";
                }
            } 
            else if (vm.selectedDocumentType === 3) {
                if (vm.templateDetail.CCHTML) {
                    payload = {
                        ModuleAction: "Save_TemplateData",
                        TemplateId: vm.$route.params.TemplateId,
                        TemplateName: vm.templateDetail.TemplateName,
                        TemplateDescription: vm.templateDetail.TemplateDescription ? vm.templateDetail.TemplateDescription : "",
                        StatusId: vm.Temp_Status.StatusId,
                        TemplateTypeId: vm.selectedTemplateType,
                        HTMLObj: "<p> </p>",
                        JSONObj: JSON.stringify(vm.templateDetail.JSONObj),
                        SubjectLineJson: "",
                        SubjectLineHTML: "",
                        FromJson: "",
                        FromHTML: "",
                        ReplyToJson: "",
                        ReplyToHTML: "",
                        CCJson: "",
                        CCHTML: vm.templateDetail.CCHTML,
                        FileName: ""
                    };
                    mandatoryFieldsFilled = true;
                } else {
                    warningMessage = "Please fill all mandatory fields!";
                }
            }

            if (!mandatoryFieldsFilled) {
                vm.$store.dispatch("toastr", {
                    type: "warning",
                    header: "Warning!",
                    message: warningMessage
                });
                return;
            }
        }

        vm.$store.dispatch("dataRequestHandler", {
          key: "Save_TemplateData",
          params: payload,
          callback: function (err, response) {
            if (err) {
              console.log("err in Save_TemplateData", err);
              vm.$store.dispatch("toastr", {
                type: "error",
                header: "Error!",
                message: "Error While Saving Template Details!"
              });
              return;
            }
            if (response) {
              console.log("response in Save_TemplateData", response);
              if (response[1] && response[1][0] && response[1][0].TemplateId) {
                vm.$store.dispatch("toastr", {
                  type: "success",
                  header: "Success!",
                  message: "Template Details Saved Successfully"
                });
                 
                vm.displaySectionValue = 'section2'
                vm.$router.push("/notificationTemplate/" + response[1][0].TemplateId);

                setTimeout(() => {
                  vm.GetTemplates_Details();
                }, 2000)
                
              }

            }
          }
        })
      },
      displaySection(section, param) {
        let vm = this;
        if (section == 'section1') {
          vm.displaySectionValue = 'section1'
        }
        else if (section == 'section2') {
          vm.displaySectionValue = 'section2'
          if(param){
            vm.selectedTemplateType = param;
          }
          // vm.GetTemplates_Details();
          // vm.getTemplateContent();
          // let templateDetail = vm.templateDetailList.filter(x => x.TemplateTypeId == param);
          // if (templateDetail.length) {
          //   vm.templateDetail = templateDetail[0]
          //   console.log("templateDetailtemplateDetail", vm.templateDetail)

          // }
          // else {
          //   vm.templateDetail = [];
          //   vm.templateDetail.TemplateName = vm.templateDetailList[0].TemplateName;
          //   vm.templateDetail.TemplateDescription = vm.templateDetailList[0].TemplateDescription;
          // }
          vm.initEditor();

        }

      },
      // getTemplateContent(){
      //   let vm = this;
      //   // vm.templateDetailList
      //   vm.templateDetail = 
      // },
      dragStart: function (user, event) {
        let vm = this;
        vm.selectedParam = user;
        console.log("useruseruser", user)
        // event.dataTransfer.setData("Text", event.target.id);
      },
      dragging: function (event) {
        // document.getElementById("demo").innerHTML =
        //   "The p element is being dragged";
      },
      allowDrop: function (event) {
        event.preventDefault();
      },
      dropHere: function (event) {
        let vm = this;
        event.preventDefault();
        // console.log("vm.selectedParamvm.selectedParam", vm.selectedParam)
        // event.preventDefault();
        // var data = event.dataTransfer.getData("text");
        // event.target.appendChild(document.getElementById(data));
        // document.getElementById("textArea").innerHTML += "#" + vm.selectedParam.label;
        vm.templateDetail.SubjectLine += "#" + vm.selectedParam.label;
        // var span = document.createElement("span");
        // var node = document.createTextNode(vm.selectedParam.label);
        // span.appendChild(node);
        // // var element = document.getElementById("div1");
        // // element.appendChild(para);
        // span.setAttribute("class", "mention");
        // span.setAttribute("data-mention-id", vm.selectedParam.id);
        // event.target.appendChild(span);
        // console.log("event.charCodeevent.charCodeevent.charCode", event.charCode)
        // var data = event.dataTransfer.getData("Text");
        // console.log("datatatatatata", data)
        // vm.selectUser(vm.selectedParam)
        // <span class="mention" data-mention-id="CheckOut" contenteditable="false">@End Date</span>

        // event.target.appendChild(document.getElementById(data));
        // document.getElementById("demo").innerHTML =
        //   "The p element was dropped";
      },
      fromdrop: function (event) {
        let vm = this;
        event.preventDefault();
        console.log("vm.selectedParamvm.selectedParam", event.target.querySelector('span'))
        if( event.target.querySelector('span') == null){
          var span = document.createElement("span");
        var node = document.createTextNode(vm.selectedParam.label);
        span.appendChild(node);
        // var element = document.getElementById("div1");
        // element.appendChild(para);
        span.setAttribute("class", "mention");
        span.setAttribute("data-mention-id", vm.selectedParam.id);
        span.setAttribute("id", "fromId")
        event.target.appendChild(span);
        }
        // console.log("event.charCodeevent.charCodeevent.charCode", event.charCode)
        // var data = event.dataTransfer.getData("Text");
        // console.log("datatatatatata", data)
        // vm.selectUser(vm.selectedParam)
        // <span class="mention" data-mention-id="CheckOut" contenteditable="false">@End Date</span>

        // event.target.appendChild(document.getElementById(data));
        // document.getElementById("demo").innerHTML =
        //   "The p element was dropped";
      },
      drop: function (event) {
        let vm = this;
        event.preventDefault();
        console.log("vm.selectedParamvm.selectedParam", vm.selectedParam)
        var span = document.createElement("span");
        var node = document.createTextNode(vm.selectedParam.label);
        span.appendChild(node);
        // var element = document.getElementById("div1");
        // element.appendChild(para);
        span.setAttribute("class", `mention`);
        span.setAttribute("data-mention-id", `${vm.selectedParam.id}/${vm.selectedParam.EntityName}`);
        console.log('DragEventCheck====>', `${vm.selectedParam.id}/${vm.selectedParam.EntityName}`);
        event.target.appendChild(span);
        // console.log("event.charCodeevent.charCodeevent.charCode", event.charCode)
        // var data = event.dataTransfer.getData("Text");
        // console.log("datatatatatata", data)
        // vm.selectUser(vm.selectedParam)
        // <span class="mention" data-mention-id="CheckOut" contenteditable="false">@End Date</span>

        // event.target.appendChild(document.getElementById(data));
        // document.getElementById("demo").innerHTML =
        //   "The p element was dropped";
      },
      isTemplateTypeDisabled(templateTypeId){
        let vm = this;
        if(vm.allowedTemplateTypes.includes(templateTypeId)){
          return false
        }else{
          return true
        }
      },
      clearContent() {
        this.editor.clearContent(true)
        this.editor.focus()
      },
      setContent() {
        // you can pass a json document
        this.editor.setContent({
          type: 'doc',
          content: [{
            type: 'paragraph',
            content: [
              {
                type: 'text',
                text: 'This is some inserted text. 👋',
              },
            ],
          }],
        }, true)
        // HTML string is also supported
        // this.editor.setContent('<p>This is some inserted text. 👋</p>')
        this.editor.focus()
      },
      // Save_TemplateData() {
      //   let vm = this;
      //   vm.$store.dispatch("dataRequestHandler", {
      //     key: "Save_TemplateData",
      //     params: {
      //       ModuleAction: "Save_TemplateData",
      //       TemplateId: vm.$route.params.TemplateId,
      //       // TemplateTypeId: vm.templateDetail.TemplateTypeId,
      //       // EntityId: vm.templateDetail.EntityId,
      //       TemplateName: vm.templateDetail.TemplateName,
      //       TemplateDescription: vm.templateDetail.TemplateDescription ? vm.templateDetail.TemplateDescription : "",
      //       // HTMLObj: vm.templateDetail.HTMLObj,
      //       // JSONObj: JSON.stringify(vm.templateDetail.JSONObj),
      //       // ActionId: vm.templateDetail.ActionId,
      //       // RecepientDetail: vm.templateDetail.RecepientDetail,
      //       StatusId: vm.Temp_Status.StatusId,
      //     },

      //     callback: function (err, response) {
      //       if (err) {
      //         console.log("err in Save_TemplateData", err);
      //         vm.$store.dispatch("toastr", {
      //           type: "error",
      //           header: "Error!",
      //           message: "Error While Saving Template Details!"
      //         });
      //         return;
      //       }
      //       if (response) {
      //         console.log("response in Save_TemplateData", response);
      //         if (response[1] && response[1][0] && response[1][0].TemplateId) {
      //           vm.$store.dispatch("toastr", {
      //             type: "success",
      //             header: "Success!",
      //             message: "Template Details Saved Successfully"
      //           });
      //           vm.displaySectionValue = 'section2'
      //           vm.$router.push("/notificationTemplate/" + response[1][0].TemplateId);
      //         }
      //       }
      //     }
      //   })
      // },
      GetTemplates_Details() {
        let vm = this;
        vm.$store.dispatch("dataRequestHandler", {
          key: "GetTemplates_Details",
          params: {
            ModuleAction: "GetTemplates_Details",
            TemplateId: vm.$route.params.TemplateId
          },
          callback: function (err, response) {
            if (err) {
              console.log("err in GetTemplates_Details", err);
              return;
            }
            if (response) {
              // console.log("response in GetTemplates_Details", response);
              if (response[0] && response[0].length > 0) {
                vm.templatesTypeList = response[0];
              }
              if (response[1] && response[1].length > 0) {
                vm.EntityNames = response[1];
              }
              console.log("response[2] ===>",response[2]);
              if (response[2] && response[2].length > 0) {
                // vm.actionTypesList = response[2];
                vm.templateDetailList = response[2]
                vm.templateDetail = response[2][0];
                console.log("response[2][0].templateTypeId ===>",response[2][0].TemplateTypeId);

                if(response[2][0].TemplateTypeId){
                  vm.selectedTemplateType = response[2][0].TemplateTypeId
                }else{
                  vm.selectedTemplateType = 1
                }

                if (vm.templateDetail.CCHTML && vm.selectedTemplateType === 5) {
                  vm.selectedDocumentType = 3;
                } else if (vm.templateDetail.SubjectLineHTML && vm.templateDetail.HTMLObj && vm.selectedTemplateType === 5) {
                  vm.selectedDocumentType = 1;
                } else if (vm.$route.params.TemplateId === '-1' && vm.selectedTemplateType === 5) {
                  vm.selectedDocumentType = 1;
                }

                // vm.Get_Action_Recepients();
                vm.Temp_Status = response[2][0].StatusId === null || response[2][0].StatusId === undefined || response[2][0].StatusId === "" || response[2][0] === "" ? { StatusId: "1", StatusName: "Active" } : { StatusId: response[2][0].StatusId, StatusName: response[2][0].StatusName };
              }
              if (response[3] && response[3].length > 0) {
                vm.statusList = response[3];
              }
              // if (response[3] && response[3].length > 0) {
              vm.initEditor();
              vm.getDocumentEntity();
              vm.getEntity();
            }
          }
        })
      },
      // Get_Action_Recepients() {
      //   let vm = this;
      //   console.log("Get_Action_Recepients")
      //   vm.$store.dispatch("dataRequestHandler", {
      //     key: "Get_Action_Recepients",
      //     params: {
      //       ModuleAction: "Get_Action_Recepients",
      //       ActionId: vm.templateDetail.ActionId
      //     },
      //     callback: function (err, response) {
      //       if (err) {
      //         console.log("err in Get_Action_Recepients", err);
      //         return;
      //       }
      //       if (response) {
      //         console.log("response in Get_Action_Recepients", response);

      //         if (response[0]) {
      //           vm.RecepientsList = response[0];
      //         }
      //       }
      //     }
      //   })

      // },
      getEntity() {
        let vm = this;
        vm.$store.dispatch("dataRequestHandler", {
          key: "Get_EntityAttributes",
          params: {
            ModuleAction: "Get_EntityAttributes",
            EntityId: null,
            Searchtext: vm.Searchtext,
          },
          callback: function (err, response) {
            if (err) {
              console.log("err in GetEntity", err);
              return;
            }
            if (response) {
              // if (response[0] && response[0].length > 0 && response[0][0].EntityName) {
              //   vm.EntityNames = response[0]
              // }
              // else
              if (response[0]) {
                // console.log("response in GetEntity", response);
                vm.AttributeNames = response[0];
                vm.initEditor();
              }
            }
          }
        })

      },
      groupBy(array, key) {
        const result = {}
        array.forEach(item => {
          if (!result[item[key]]) {
            result[item[key]] = []
          }
          result[item[key]].push(item)
        })
        return result
      },
      getDocumentEntity() {
        let vm = this;
        vm.$store.dispatch("dataRequestHandler", {
          key: "Get_AllDocument_EntityAttributes",
          params: {
            ModuleAction: "Get_AllDocument_EntityAttributes",
            EntityId: null,
            templateId: vm.DocumentTemplateId,
            Searchtext: vm.Searchtext === ''? null : vm.Searchtext,
          },
          callback: function (err, response) {
            if (err) {
              console.log("err in GetEntity", err);
              return;
            }
            if (response) {
              // if (response[0] && response[0].length > 0 && response[0][0].EntityName) {
              //   vm.EntityNames = response[0]
              // }
              // else
              if (response[0]) {
                console.log("Get_AllDocument_EntityAttributes===>", response[0]);
                vm.DocumentAttributes = response[0];
                vm.initEditor();
              }
            }
          }
        })

      },
      InsertDocumentEntityAttribute() {
        let vm = this;
        vm.$store.dispatch("dataRequestHandler", {
          key: "InsertDocumentEntityAttribute",
          params: {
            ModuleAction: "InsertDocumentEntityAttribute",
            EntityName: "Document",
            TemplateId: vm.DocumentTemplateId,
            AttributeName: vm.DocumentAttributeName,
            ColumnName: vm.DocumentColumnName
          },
          callback: function (err, response) {
            if (err) {
              console.log("err in GetEntity", err);
              return;
            }
            if (response) {
              vm.isDocumentCustomTabModal = false;
              console.log("InsertDocumentEntityAttribute===>", response);
              vm.DocumentAttributeName = '';
              vm.getDocumentEntity();
              vm.initEditor();
              // vm.listGrouping();
              
              
            }
          }
        })

      },
      initEditor() {
        let vm = this, filteredParams = [];
        if (vm.editor) {
          vm.editor.destroy()
        }
        if (vm.subjectEditor) {
          vm.subjectEditor.destroy()
        }
        if(vm.fromEditor){
          vm.fromEditor.destroy()
        }
        if(vm.toEditor){
          vm.toEditor.destroy()
        }
        if(vm.ccEditor){
          vm.ccEditor.destroy()
        }
        // console.log("AttributeNames", vm.AttributeNames)
        if (vm.AttributeNames) {
          Object.keys(vm.AttributeNames).forEach(function (param) {
            // console.log("param", vm.AttributeNames[param])
            filteredParams.push({ label: vm.AttributeNames[param].AttributeName, id: vm.AttributeNames[param].ColumnName, EntityName: vm.AttributeNames[param].EntityName })
          })
        }
        // console.log('selectedDocumentType======>test', vm.selectedDocumentType);
        if(vm.DocumentAttributes && vm.selectedTemplateType === 5 && this.selectedDocumentType === 1){
          Object.keys(vm.DocumentAttributes).forEach(function (param) {
            // console.log("param", vm.DocumentAttributes[param])
            filteredParams.unshift({ label: vm.DocumentAttributes[param].AttributeName, id: vm.DocumentAttributes[param].ColumnName, EntityName: vm.DocumentAttributes[param].EntityName })
          })
        }
        vm.parameters = filteredParams

        this.subjectEditor = new Editor({
          extensions: [
            new Blockquote(),
            new CodeBlock(),
            new HardBreak(),
            new Heading({ levels: [1, 2, 3] }),
            new BulletList(),
            new OrderedList(),
            new ListItem(),
            new TodoItem(),
            new TodoList(),
            new Bold(),
            new Code(),
            new Italic(),
            new Link(),
            new Strike(),
            new Underline(),
            new History(),
            new HorizontalRule(),
            new Table({
              resizable: true,
            }),
            new TableCell(),
            new TableHeader(),
            new TableRow(),
            new Image(),
            new Mention({
              // matcher: {
              //   char: '^',
              // },
              // a list of all suggested items
              items: () => filteredParams,
              // is called when a suggestion starts
              onEnter: ({
                items, query, range, command, virtualNode,
              }) => {
                vm.query = query
                vm.filteredUsers = items
                vm.suggestionRange = range
                vm.renderPopup(virtualNode)
                // we save the command for inserting a selected mention
                // this allows us to call it inside of our custom popup
                // via keyboard navigation and on click
                vm.insertMention = command
              },
              // is called when a suggestion has changed
              onChange: ({
                items, query, range, virtualNode,
              }) => {
                vm.query = query
                vm.filteredUsers = items
                vm.suggestionRange = range
                vm.navigatedUserIndex = 0
                vm.renderPopup(virtualNode)
              },
              // is called when a suggestion is cancelled
              onExit: () => {
                // reset all saved values
                vm.query = null
                vm.filteredUsers = []
                vm.suggestionRange = null
                vm.navigatedUserIndex = 0
                vm.destroyPopup()
              },
              onKeyDown: ({ event }) => {
                // pressing up arrow
                if (event.keyCode === 38) {
                  vm.upHandler()
                  return true
                }
                // pressing down arrow
                if (event.keyCode === 40) {
                  vm.downHandler()
                  return true
                }
                // pressing enter
                if (event.keyCode === 13) {
                  vm.enterHandler()
                  return true
                }
                return false
              },
              // is called when a suggestion has changed
              // this function is optional because there is basic filtering built-in
              // you can overwrite it if you prefer your own filtering
              // in this example we use fuse.js with support for fuzzy search
              onFilter: (items, query) => {
                if (!query) {
                  return items
                }
                const fuse = new Fuse(items, {
                  threshold: 0.2,
                  keys: ['label'],
                })
                return fuse.search(query)
              },
            }),
          ],
          onUpdate: ({ getJSON, getHTML }) => {
            vm.templateDetail.SubjectLineJson = getJSON()
            vm.templateDetail.SubjectLineHTML = getHTML()
          },
          // content: vm.entityNotificationTemplate.templateHtml,
        })

        this.fromEditor = new Editor({
          extensions: [
            new Blockquote(),
            new CodeBlock(),
            new HardBreak(),
            new Heading({ levels: [1, 2, 3] }),
            new BulletList(),
            new OrderedList(),
            new ListItem(),
            new TodoItem(),
            new TodoList(),
            new Bold(),
            new Code(),
            new Italic(),
            new Link(),
            new Strike(),
            new Underline(),
            new History(),
            new HorizontalRule(),
            new Table({
              resizable: true,
            }),
            new TableCell(),
            new TableHeader(),
            new TableRow(),
            new Image(),
            new Mention({
              // matcher: {
              //   char: '^',
              // },
              // a list of all suggested items
              items: () => filteredParams,
              // is called when a suggestion starts
              onEnter: ({
                items, query, range, command, virtualNode,
              }) => {
                vm.query = query
                vm.filteredUsers = items
                vm.suggestionRange = range
                vm.renderPopup(virtualNode)
                // we save the command for inserting a selected mention
                // this allows us to call it inside of our custom popup
                // via keyboard navigation and on click
                vm.insertMention = command
              },
              // is called when a suggestion has changed
              onChange: ({
                items, query, range, virtualNode,
              }) => {
                vm.query = query
                vm.filteredUsers = items
                vm.suggestionRange = range
                vm.navigatedUserIndex = 0
                vm.renderPopup(virtualNode)
              },
              // is called when a suggestion is cancelled
              onExit: () => {
                // reset all saved values
                vm.query = null
                vm.filteredUsers = []
                vm.suggestionRange = null
                vm.navigatedUserIndex = 0
                vm.destroyPopup()
              },
              onKeyDown: ({ event }) => {
                // pressing up arrow
                if (event.keyCode === 38) {
                  vm.upHandler()
                  return true
                }
                // pressing down arrow
                if (event.keyCode === 40) {
                  vm.downHandler()
                  return true
                }
                // pressing enter
                if (event.keyCode === 13) {
                  vm.enterHandler()
                  return true
                }
                return false
              },
              // is called when a suggestion has changed
              // this function is optional because there is basic filtering built-in
              // you can overwrite it if you prefer your own filtering
              // in this example we use fuse.js with support for fuzzy search
              onFilter: (items, query) => {
                if (!query) {
                  return items
                }
                const fuse = new Fuse(items, {
                  threshold: 0.2,
                  keys: ['label'],
                })
                return fuse.search(query)
              },
            }),
          ],
          onUpdate: ({ getJSON, getHTML }) => {
            vm.templateDetail.FromJson = getJSON()
            vm.templateDetail.FromHTML = getHTML()
          },
          // content: vm.entityNotificationTemplate.templateHtml,
        })

        this.toEditor = new Editor({
          extensions: [
            new Blockquote(),
            new CodeBlock(),
            new HardBreak(),
            new Heading({ levels: [1, 2, 3] }),
            new BulletList(),
            new OrderedList(),
            new ListItem(),
            new TodoItem(),
            new TodoList(),
            new Bold(),
            new Code(),
            new Italic(),
            new Link(),
            new Strike(),
            new Underline(),
            new History(),
            new HorizontalRule(),
            new Table({
              resizable: true,
            }),
            new TableCell(),
            new TableHeader(),
            new TableRow(),
            new Image(),
            new Mention({
              // matcher: {
              //   char: '^',
              // },
              // a list of all suggested items
              items: () => filteredParams,
              // is called when a suggestion starts
              onEnter: ({
                  items, query, range, command, virtualNode,
              }) => {
                vm.query = query
                vm.filteredUsers = items
                vm.suggestionRange = range
                vm.renderPopup(virtualNode)
                // we save the command for inserting a selected mention
                // this allows us to call it inside of our custom popup
                // via keyboard navigation and on click
                vm.insertMention = command
              },
              // is called when a suggestion has changed
              onChange: ({
                items, query, range, virtualNode,
              }) => {
                vm.query = query
                vm.filteredUsers = items
                vm.suggestionRange = range
                vm.navigatedUserIndex = 0
                vm.renderPopup(virtualNode)
              },
              // is called when a suggestion is cancelled
              onExit: () => {
                // reset all saved values
                vm.query = null
                vm.filteredUsers = []
                vm.suggestionRange = null
                vm.navigatedUserIndex = 0
                vm.destroyPopup()
              },
              onKeyDown: ({ event }) => {
                // pressing up arrow
                if (event.keyCode === 38) {
                  vm.upHandler()
                  return true
                }
                // pressing down arrow
                if (event.keyCode === 40) {
                  vm.downHandler()
                  return true
                }
                // pressing enter
                if (event.keyCode === 13) {
                  vm.enterHandler()
                  return true
                }
                return false
              },
              // is called when a suggestion has changed
              // this function is optional because there is basic filtering built-in
              // you can overwrite it if you prefer your own filtering
              // in this example we use fuse.js with support for fuzzy search
              onFilter: (items, query) => {
                if (!query) {
                  return items
                }
                const fuse = new Fuse(items, {
                  threshold: 0.2,
                  keys: ['label'],
                })
                return fuse.search(query)
              },
            }),
          ],
          onUpdate: ({ getJSON, getHTML }) => {
            vm.templateDetail.ReplyToJson = getJSON()
            vm.templateDetail.ReplyToHTML = getHTML()
          },
          // content: vm.entityNotificationTemplate.templateHtml,
        })
        
        this.ccEditor = new Editor({
          extensions: [
            new Blockquote(),
            new CodeBlock(),
            new HardBreak(),
            new Heading({ levels: [1, 2, 3] }),
            new BulletList(),
            new OrderedList(),
            new ListItem(),
            new TodoItem(),
            new TodoList(),
            new Bold(),
            new Code(),
            new Italic(),
            new Link(),
            new Strike(),
            new Underline(),
            new History(),
            new HorizontalRule(),
            new Table({
              resizable: true,
            }),
            new TableCell(),
            new TableHeader(),
            new TableRow(),
            new Image(),
            new Mention({
              // matcher: {
              //   char: '^',
              // },
              // a list of all suggested items
              items: () => filteredParams,
              // is called when a suggestion starts
              onEnter: ({
                items, query, range, command, virtualNode,
              }) => {
                vm.query = query
                vm.filteredUsers = items
                vm.suggestionRange = range
                vm.renderPopup(virtualNode)
                // we save the command for inserting a selected mention
                // this allows us to call it inside of our custom popup
                // via keyboard navigation and on click
                vm.insertMention = command
              },
              // is called when a suggestion has changed
              onChange: ({
                items, query, range, virtualNode,
              }) => {
                vm.query = query
                vm.filteredUsers = items
                vm.suggestionRange = range
                vm.navigatedUserIndex = 0
                vm.renderPopup(virtualNode)
              },
              // is called when a suggestion is cancelled
              onExit: () => {
                // reset all saved values
                vm.query = null
                vm.filteredUsers = []
                vm.suggestionRange = null
                vm.navigatedUserIndex = 0
                vm.destroyPopup()
              },
              onKeyDown: ({ event }) => {
                // pressing up arrow
                if (event.keyCode === 38) {
                  vm.upHandler()
                  return true
                }
                // pressing down arrow
                if (event.keyCode === 40) {
                  vm.downHandler()
                  return true
                }
                // pressing enter
                if (event.keyCode === 13) {
                  vm.enterHandler()
                  return true
                }
                return false
              },
              // is called when a suggestion has changed
              // this function is optional because there is basic filtering built-in
              // you can overwrite it if you prefer your own filtering
              // in this example we use fuse.js with support for fuzzy search
              onFilter: (items, query) => {
                if (!query) {
                  return items
                }
                const fuse = new Fuse(items, {
                  threshold: 0.2,
                  keys: ['label'],
                })
                return fuse.search(query)
              },
            }),
          ],
          onUpdate: ({ getJSON, getHTML }) => {
            vm.templateDetail.CCJson = getJSON()
            vm.templateDetail.CCHTML = getHTML()
          },
          // content: vm.entityNotificationTemplate.templateHtml,
        })

        this.editor = new Editor({
          extensions: [
            new Blockquote(),
            new CodeBlock(),
            new HardBreak(),
            new Heading({ levels: [1, 2, 3] }),
            new BulletList(),
            new OrderedList(),
            new ListItem(),
            new TodoItem(),
            new TodoList(),
            new Bold(),
            new Code(),
            new Italic(),
            new Link(),
            new Strike(),
            new Underline(),
            new History(),
            new HorizontalRule(),
            new Table({
              resizable: true,
            }),
            new TableCell(),
            new TableHeader(),
            new TableRow(),
            new Image(),
            new Mention({
              // matcher: {
              //   char: '^',
              // },
              // a list of all suggested items
              items: () => filteredParams,
              // is called when a suggestion starts
              onEnter: ({
                  items, query, range, command, virtualNode,
              }) => {
                vm.query = query
                vm.filteredUsers = items
                vm.suggestionRange = range
                vm.renderPopup(virtualNode)
                // we save the command for inserting a selected mention
                // this allows us to call it inside of our custom popup
                // via keyboard navigation and on click
                vm.insertMention = command
              },
              // is called when a suggestion has changed
              onChange: ({
                items, query, range, virtualNode,
              }) => {
                vm.query = query
                vm.filteredUsers = items
                vm.suggestionRange = range
                vm.navigatedUserIndex = 0
                vm.renderPopup(virtualNode)
              },
              // is called when a suggestion is cancelled
              onExit: () => {
                // reset all saved values
                vm.query = null
                vm.filteredUsers = []
                vm.suggestionRange = null
                vm.navigatedUserIndex = 0
                vm.destroyPopup()
              },
              onKeyDown: ({ event }) => {
                // pressing up arrow
                if (event.keyCode === 38) {
                  vm.upHandler()
                  return true
                }
                // pressing down arrow
                if (event.keyCode === 40) {
                  vm.downHandler()
                  return true
                }
                // pressing enter
                if (event.keyCode === 13) {
                  vm.enterHandler()
                  return true
                }
                return false
              },
              // is called when a suggestion has changed
              // this function is optional because there is basic filtering built-in
              // you can overwrite it if you prefer your own filtering
              // in this example we use fuse.js with support for fuzzy search
              onFilter: (items, query) => {
                if (!query) {
                  return items
                }
                const fuse = new Fuse(items, {
                  threshold: 0.2,
                  keys: ['label'],
                })
                return fuse.search(query)
              },
            }),
          ],
          onUpdate: ({ getJSON, getHTML }) => {
            //console.log("DragEventCheck====>onUpdate-2", {getHTML: getHTML(), selectedParam: vm.selectedParam.EntityName })
            vm.templateDetail.JSONObj = getJSON()
            vm.templateDetail.HTMLObj = getHTML()
          },
          // content: vm.entityNotificationTemplate.templateHtml,
        })
        
        if (vm.templateDetail && vm.templateDetail.HTMLObj) {
          vm.editor.setContent(vm.templateDetail.HTMLObj)
          // vm.content = response[3][0].HTMLObj
        }
        if (vm.templateDetail && vm.templateDetail.SubjectLineHTML) {
          vm.subjectEditor.setContent(vm.templateDetail.SubjectLineHTML)
          // vm.content = response[3][0].HTMLObj
        }
        if (vm.templateDetail && vm.templateDetail.FromHTML) {
          vm.fromEditor.setContent(vm.templateDetail.FromHTML)
          // vm.content = response[3][0].HTMLObj
        }
        if (vm.templateDetail && vm.templateDetail.ReplyToHTML) {
          vm.toEditor.setContent(vm.templateDetail.ReplyToHTML)
          // vm.content = response[3][0].HTMLObj
        }
        if (vm.templateDetail && vm.templateDetail.CCHTML) {
          vm.ccEditor.setContent(vm.templateDetail.CCHTML)
          // vm.content = response[3][0].HTMLObj
        }
      },
      upHandler() {
        this.navigatedUserIndex = ((this.navigatedUserIndex + this.filteredUsers.length) - 1) % this.filteredUsers.length
      },
      // navigate to the next item
      // if it's the last item, navigate to the first one
      downHandler() {
        this.navigatedUserIndex = (this.navigatedUserIndex + 1) % this.filteredUsers.length
        console.log("navigatedUserIndex", this.navigatedUserIndex)
      },
      enterHandler() {
        const user = this.filteredUsers[this.navigatedUserIndex]
        // user.
        console.log("user", user)
        if (user) {
          this.selectUser(user)
        }
      },
      // we have to replace our suggestion text with a mention
      // so it's important to pass also the position of your suggestion text
      selectUser(user) {
        console.log("this.suggestionRangethis.suggestionRange", this.suggestionRange)
        this.insertMention({
          range: this.suggestionRange,
          attrs: {
            id: user.id,
            label: user.label,
          },
        })
        this.editor.focus()
      },
      // renders a popup with suggestions
      // tiptap provides a virtualNode object for using popper.js (or tippy.js) for popups
      renderPopup(node) {
        if (this.popup) {
          return
        }
        this.popup = tippy(node, {
          content: this.$refs.suggestions,
          trigger: 'mouseenter',
          interactive: true,
          theme: 'dark',
          placement: 'top-start',
          inertia: true,
          duration: [400, 200],
          showOnInit: true,
          arrow: true,
          arrowType: 'round',
        })
        // we have to update tippy whenever the DOM is updated
        if (MutationObserver) {
          this.observer = new MutationObserver(() => {
            this.popup.popperInstance.scheduleUpdate()
          })
          this.observer.observe(this.$refs.suggestions, {
            childList: true,
            subtree: true,
            characterData: true,
          })
        }
      },
      destroyPopup() {
        if (this.popup) {
          this.popup.destroy()
          this.popup = null
        }
        if (this.observer) {
          this.observer.disconnect()
        }
      },
      selectDocument(selectedDocumentType) {
        // this.selectedDocumentType =  null;
        let vm = this;
        // console.log('selectedDocumentType======>test', selectedDocumentType , typeof selectedDocumentType);
        vm.selectedDocumentType = selectedDocumentType;
        vm.initEditor();
      },
      openCustomTabModel(){
        let vm = this;      
        let fullUrl = window.location.href;
        let notificationId = fullUrl.split("/").slice(-1)[0];
        if(notificationId === "-1"){
          vm.isDocumentCustomTabModal = false;
          // alert("Please Save the Template");
          vm.isCustomTab = false;
          vm.$store.dispatch("toastr", {
                type: "warning",
                header: "Warning!",
                message: "Please Save the Template!"
        });
        }else{
          vm.DocumentTemplateId = parseInt(window.location.href.split("/").slice(-1)[0]);
          vm.isDocumentCustomTabModal = true;
          vm.modalParams = {
            popupTitle: `Create Custom Tab`,
            popupMessage: null,
            isRUPopup: true,
            yesButtontext: "Add Custom Tab",
            noButtonText: "Cancel",
            yesButtonCallback: vm.AddTab,
            noButtonCallback: vm.closeCustomTabModal,
            actionButtons: true,
          };
        }
      },
    },
    computed: {
      test(){
        var span = document.getElementsByClassName("mention");
        console.log("document.getElementById(from).contains(span)", document.getElementById("from").contains(span))
        // return 
      },
      hasResults() {
        return this.filteredUsers.length
      },
      showSuggestions() {
        return this.query || this.hasResults
      },
      listGrouping() {
        let vm = this;
        return vm.groupBy(this.parameters, 'EntityName')
      }
    },
    watch: {
      Searchtext() {
        let vm = this;
        vm.getEntity();
        vm.getDocumentEntity();
      },
      selectedTemplateType(){
        let vm = this;
        if(vm.selectedTemplateType === "5"){
          // console.log('selectedTemplateType==========>', vm.selectedTemplateType);
          vm.listGrouping();
        }
        
      }
    },
    mounted() {
      let vm = this;
      // vm.getEntity();
      vm.DocumentTemplateId = parseInt(window.location.href.split("/").slice(-1)[0]);
      if(vm.DocumentTemplateId !== -1){
        vm.isCustomTab = true;
      }else{
        vm.isCustomTab = false;
      }
      vm.GetTemplates_Details();
      vm.initEditor();
      document.addEventListener("DOMContentLoaded", vm.init)
    }
  }
</script>
<style>
  .droptarget {
    float: left;
    width: 100px;
    height: 35px;
    margin: 15px;
    padding: 10px;
    border: 1px solid #aaaaaa;
  }
  .container.documentTemplate{
    display: flex;
    height: 150px;
    justify-content: center;
  }
  .documentTemplate .box {
    width: 200px;
    padding: 15px;
    margin: 0;
    background-color: #E7E6E6;
    border-radius: 0;
    display: grid;
    justify-content: space-evenly;
    align-items: center;
    cursor: pointer;
    text-align: center;
    align-items: center;
  }
  .documentTemplate .box:first-child {
    border-top-left-radius: 20px;
    border-bottom-left-radius: 20px;
  }
  .documentTemplate .box:last-child {
    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;
  }
  .documentTemplate .box2{
    cursor: not-allowed;
  }
  .documentTemplate .box3{
    background-color: #E7E6E6;
    /* cursor: not-allowed; */
  }
  .documentTemplate .box.active {
      background-color: #818181;
  }
 .documentTemplate .box span{
    color: #bfbfbf;
    font-size: 14px;
  }
  .documentTemplateBoxes{
    display: flex;
    border: 2px dashed #b5b5b5;
    border-radius: 21px;
  }
  .customTab .modal{
    min-width: 30% !important;
  }
</style>